import { CollectLpIncentiveRewardsTransactionStep } from 'uniswap/src/features/transactions/liquidity/steps/collectIncentiveRewards'

export type CollectLpIncentiveRewardsSteps = CollectLpIncentiveRewardsTransactionStep

export type CollectLpIncentiveRewardsFlow = {
  claims: CollectLpIncentiveRewardsTransactionStep[]
}

export function orderCollectLpIncentiveRewardsSteps(
  flow: CollectLpIncentiveRewardsFlow,
): CollectLpIncentiveRewardsSteps[] {
  return [...flow.claims]
}
